import service from '@/services'

// getters
const getters = {
}

// actions
const actions = {
  queryAdSlot: ({commit}, payload) => {
    return service.queryAdSlot(commit, payload)
  },
  queryPageAdCreative: ({commit}, payload) => {
    return service.queryPageAdCreative(commit, payload)
  },
  addorupdateAdCreative: ({commit}, payload) => {
    return service.addorupdateAdCreative(commit, payload)
  },
  deleteAdCreative: ({commit}, payload) => {
    return service.deleteAdCreative(commit, payload)
  },
  overviewAdStat: ({commit}, payload) => {
    return service.overviewAdStat(commit, payload)
  },
  trendAdStat: ({commit}, payload) => {
    return service.trendAdStat(commit, payload)
  },
  pageAdStat: ({commit}, payload) => {
    return service.pageAdStat(commit, payload)
  },
  reportDataAdStat: ({commit}, payload) => {
    return service.reportDataAdStat(commit, payload)
  }
}

// mutations
const mutations = {
}

export default {
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ad.js